import React, { useDebugValue } from 'react'
import Header from './Header'
import useNowPlayingMovies from '../hooks/useNowPlayingMovies';
import MainContainer from './MainContainer';
import SecondaryContainer from './SecondaryContainer';
import useNowPopularMovies from '../hooks/usePopularMovies';
import useTopRatedMovies from '../hooks/useTopRatedMovies';
import useNowUpcomingMovies from '../hooks/useUpcomingMovies';
import GPTSearch from './GPTSearch';
import { useSelector } from 'react-redux';

const Browse = () => {
  const gptSearch = useSelector(store => store.gpt.gptSlice);
  useNowPlayingMovies();
  useNowPopularMovies();
  useTopRatedMovies();
  useNowUpcomingMovies();
  return (
    <div>
      <Header />
      {gptSearch ? <GPTSearch /> : <><MainContainer /><SecondaryContainer /></>}
    </div>
  )
}
export default Browse